import { BsyUtils } from "./Utils";

export function BsyWebSocket() {
    window.FX.WebSocket = window.FX.WebSocket || {
        _initSocket: function (t) {
            var e = this;
            e.onMap = {};
            var url = window.FX.CONFIG.HOST.WEBSOCKET;
            e.socket = new WebSocket(url);
            e.socket.onopen = function () {
                t && t();
            }
            e.socket.onmessage = function (evt) {
                e._onMessage(evt);
            };
            e.socket.onclose = function (evt) {
                e._onClose(evt);
                e.socket = null;
            };
            e.socket.onerror = function (evt) {
                e._onError(evt);
                e.socket = null;
            };
            e.Timer = setInterval(function () {
                if (e.socket) {
                    e._send({ "type": "pong" });
                    // console.log("心跳 "+ new Date());
                }
                else {
                    clearInterval(e.Timer);
                }
            }, 40 * 1000)
        },
        _onMessage: function (evt) {
            var _this = this;
            if (evt.data) {
                // console.log("_onMessage:"+evt.data);
                var a = JSON.parse(evt.data);
                switch (a.type) {
                    case "ping": {
                        this._cleanExpTime();
                        return;
                    }

                    case "padForward":
                        {
                            a && a.file && BsyUtils.applyFunc(_this, _this.onMap[a.signatureKey].onStopEdit, [a.file], !1)
                            return;
                        }
                    case "Connect":
                        {
                            BsyUtils.applyFunc(_this, _this.onMap[a.signatureKey].onConnect, [], !1)
                            return;
                        }

                    default:
                        a && a.signatureKey && BsyUtils.applyFunc(_this, _this.onMap[a.signatureKey].onMessage, [a], !1)
                }
            }

        },
        _onClose: function (evt) {
            var _this = this;
            if (evt.data) {
                var a = JSON.parse(evt.data);
                a && a.signatureKey && BsyUtils.applyFunc(_this, _this.onMap[a.signatureKey].onClose, [a], !1)
            }
        },
        _onError: function (evt) {
            var _this = this;
            if (evt.data) {
                var a = JSON.parse(evt.data);
                a && a.signatureKey && BsyUtils.applyFunc(_this, _this.onMap[a.signatureKey].onError, [a], !1)
            }
        },
        _send: function (obj) {
            this.socket && this.socket.send(JSON.stringify(obj))
        },
        _cleanExpTime: function () {
            //清理过期的token
            var _this = this;
            BsyUtils.forEach(this.onMap, function (a, b) {
                if (b.expTime < (new Date()).getTime()) {
                    _this._send({ "type": "del", "signatureKey": a });
                    delete _this.onMap[a];
                }
            })
        },
        _replacesignatureKey: function (t, d, e) {
            this.onMap[t] = e
            var obj = {
                "type": "add",
                "signatureKey": t,
                "expTime": e.expTime,
                'widgetType': e.widgetType,
                "widgetName": e.widgetName,
                "appid": window.FX.STATIC.APPID,
                "formid": window.FX.STATIC.ENTRYID,
                'user': window.FX.STATIC.user ? window.FX.STATIC.user._id : '',
                FTOKEN: window.FX.STATIC.FTOKEN,
                nickname: window.FX.STATIC.user ? window.FX.STATIC.user.nickname : '',
                maxFileCount: e.maxFileCount,
                maxFileSize: e.maxFileSize,
                onlyCamera: e.onlyCamera,
                compressed: e.compressed,
                wxOriginalComponent: e.wxOriginalComponent,
                watermarkSwitch: e.watermarkSwitch,
                watermarkAddPhoto: e.watermarkAddPhoto,
                watermarkPosition: e.watermarkPosition,
                watermarkFieldTitle: e.watermarkFieldTitle,
                watermarkSize: e.watermarkSize,
                watermarkColor: e.watermarkColor,
                watermarkField: e.watermarkField,
                formdata: e.formdata,
                watermarkFixedField: e.watermarkFixedField,
                subformZindex: e.subformZindex,
            }
            this._send(obj)
            if (this.onMap[d]) {
                this._send({ "type": "del", "signatureKey": d });
                delete this.onMap[d];
            }
            BsyUtils.applyFunc(this, this.onMap[t].onCreateQR, [], !1)
        },
        on: function (t, d, e) {
            var _this = this;
            if (!(BsyUtils.isEmpty(t) || this.onMap && this.onMap[t])) {
                // console.log("手写签名id+"+t);
                if (!this.socket) {
                    this._initSocket(function () {
                        _this._replacesignatureKey(t, d, e);
                    })
                }
                else {
                    _this._replacesignatureKey(t, d, e);
                }
            }
        }
    };
}


